import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decisionApi, type Agent } from '../../api/decision';

export function AIAgentConsolePage() {
  const [agents, setAgents] = useState<Agent[]>([]);

  useEffect(() => {
    void decisionApi.listAgents().then(setAgents);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">AI Agent Console</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Chief Executive, Financial, Operations, Marketing and domain-specific autonomous AI agents.</p>
      <Link to="/decision" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← Decision Center</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {agents.map((a) => (
          <div key={a.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="font-medium">{a.name}</p>
            <p className="text-xs text-slate-500 capitalize">{a.role.replace(/_/g, ' ')} · {a.status}</p>
            {a.description && <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{a.description}</p>}
            {a.capabilities && (
              <div className="mt-2 flex flex-wrap gap-1">
                {a.capabilities.map((c) => (
                  <span key={c} className="rounded bg-indigo-100 px-2 py-0.5 text-xs dark:bg-indigo-900/40">{c}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
